import { DropdownMenu as M } from 'radix-ui';
import { type ReactNode } from 'react';

export interface ItemMenu {
  rotulo: string;
  icone?: ReactNode;
  aoSelecionar: () => void;
  perigoso?: boolean;
  /** Fica visível, mas não pode ser escolhido (`detalhe` diz por quê). */
  desabilitado?: boolean;
  /** Linha menor abaixo do rótulo. */
  detalhe?: string;
}

interface DropdownMenuProps {
  gatilho: ReactNode;
  itens: readonly ItemMenu[];
  cabecalho?: ReactNode;
}

export function DropdownMenu({ gatilho, itens, cabecalho }: DropdownMenuProps) {
  return (
    <M.Root>
      <M.Trigger asChild>{gatilho}</M.Trigger>
      <M.Portal>
        <M.Content
          align="end"
          sideOffset={6}
          className="z-50 min-w-52 rounded-cartao border border-borda bg-superficie-elevada p-1 shadow-alta animate-surgir"
        >
          {cabecalho && (
            <>
              <div className="px-2.5 py-2">{cabecalho}</div>
              <M.Separator className="my-1 h-px bg-borda" />
            </>
          )}
          {itens.map((item) => (
            <M.Item
              key={item.rotulo}
              onSelect={item.aoSelecionar}
              disabled={item.desabilitado ?? false}
              className={
                'flex cursor-default items-center gap-2 rounded-controle px-2.5 py-1.5 text-base outline-none data-highlighted:bg-superficie-hover data-disabled:opacity-50 [&_svg]:size-4 ' +
                (item.perigoso ? 'text-perigo' : 'text-texto')
              }
            >
              {item.icone}
              {item.detalhe ? (
                <span className="flex flex-col">
                  {item.rotulo}
                  <span className="text-sm text-texto-suave">{item.detalhe}</span>
                </span>
              ) : (
                item.rotulo
              )}
            </M.Item>
          ))}
        </M.Content>
      </M.Portal>
    </M.Root>
  );
}
